import { AbstractControlOptions } from '@angular/forms';

import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorDataService } from '../editor-data/editor-data.service';


export class EditorBookingItemSettingWorkflow extends EditorBookingItemSetting {
  settingClassName = 'Workflow';
  serializedName = 'workflowId';
  showSummary = false;

  id: string;

  constructor(obj?: any) {
    super({
      inheritableType: obj?.inheritableType ?? null
    });
    this.id = obj?.id ?? null;
  }

  createCopy(): EditorBookingItemSettingWorkflow {
    return new EditorBookingItemSettingWorkflow({
      id: this.id,
      inheritableType: this.inheritableType
    });
  }

  getTitle(): string {
    return $localize `Form workflow`;
  }

  getHelpText(): string {
    return $localize `Which form workflow should be used for bookings?`;
  }

  hasSummary(): boolean {
    return !!this.id;
  }

  getIdAsString(workflowNames: { id: string, name: string }[]): string {
    if (this.id === null) { return ''; }
    return workflowNames
      .find(workflowName => workflowName.id === this.id)?.name ?? $localize `Not valid`;
  }

  getFormConfig(_editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  } {
    return {
      controlsConfig: { id: [this.id] }
    };
  }

  getFormValues(): any {
    return { id: this.id };
  }

  getEmptyFormValues(): any {
    return { id: null };
  }

  applyFormValues(formValues: any) {
    this.id = formValues.id;
  }

  getSerializedValues(): any {
    return this.id;
  }
}
